module.exports = __webpack_public_path__ + "media/images/landing/remote-meeting-452bdfd41a77bccc6bb8538ba948722c.svg";